import { Observable } from 'rxjs';
import { Actions } from '../../actions';
import * as earnings from '../../../sdk/earnings';
import {
  GenerateExportUrl,
  GenerateExportUrlSuccess,
  GenerateExportUrlError,
} from '../action-creators';
import { GENERATE_EXPORT_URL } from '../actions';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';

export const earningsGenerateExportUrlEpic = (
  action$: Observable<Actions>
): Observable<Actions> =>
  action$.pipe(
    ofType<Actions, GenerateExportUrl>(GENERATE_EXPORT_URL),
    mergeMap(async (action) => {
      try {
        const result = await earnings.generateExportUrl(
          action.ownerType,
          action.ownerId,
          action.reportFormat,
          action.reportDate
        );
        
        return new GenerateExportUrlSuccess(result.requestId, action.ownerId);
      } catch (err) {
        return new GenerateExportUrlError((err as Error).message);
      }
    })
  );
